import { DotsMenu, MenuItem } from '~/commonComponents/DotsMenu';
import { CandidateStatus } from '~/domain/PermanentJobs';
import { useToggle } from '~/hooks';
import { OutlineMailIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { useNavigateToCreateInterview } from '~/components/PermanentJobsV2/CreateOnsiteInterview/hooks/useNavigateToCreateInterview';
import { InviteToExistingInterviewModal } from './InviteToExistingInterviewModal';

interface IInviteColumnCellProps {
  candidateId: string;
  jobPostingId: string;
  officeId: string;
  officeStatus: CandidateStatus;
  professionalId: string;
  professionalName: string;
}

export const InviteColumnCell = ({
  candidateId,
  jobPostingId,
  officeId,
  officeStatus,
  professionalId,
  professionalName,
}: IInviteColumnCellProps) => {
  const navigateToCreateInterview = useNavigateToCreateInterview();
  const [isInvitePopupOpen, controls] = useToggle();

  const isHired = officeStatus === CandidateStatus.Hired;
  const isRejected = officeStatus === CandidateStatus.Rejected;

  const canInvite = !isHired && !isRejected;

  const handleInviteNewInterviews = () => {
    navigateToCreateInterview({ jobPostingId, professionalId, professionalName });
  };

  if (!canInvite) {
    return null;
  }

  return (
    <>
      <DotsMenu
        dataCy="invite-menu-button"
        position="bottom-right"
        CustomMenuIcon={() => (
          <button
            aria-label="Invite candidate"
            data-candidate-id={candidateId}
            data-job-posting-id={jobPostingId}
            data-testid="invite-column-cell"
            style={{ background: 'transparent', width: 'fit-content', marginLeft: 16 }}
          >
            <OutlineMailIcon color={colors.secondary[500]} />
          </button>
        )}
      >
        <MenuItem dataCy="existing-interview" text="Existing Interview" onClick={controls.setOn} />
        <MenuItem dataCy="new-interview" text="New Interview" onClick={handleInviteNewInterviews} />
      </DotsMenu>
      <InviteToExistingInterviewModal
        isOpen={isInvitePopupOpen}
        professionalId={professionalId}
        jobPostingId={jobPostingId}
        officeId={officeId}
        onClose={controls.setOff}
      />
    </>
  );
};
